import { lazy } from 'react';

export const ConfirmEmailVaultVerify = lazy(() => import('./ConfirmEmailVaultVerify.component'));
